import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=dedda980&scoped=true&"
import script from "./StatusLabel.vue?vue&type=script&lang=js&"
export * from "./StatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&id=dedda980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedda980",
  null
  
)

export default component.exports